<script>
  export default {
    props: {
      active: {
        type: Boolean,
        default: false,
      },
      imageClass: {
        type: String,
        default: '',
      },
      src: {
        type: String,
        default: '',
      },
      width: {
        type: [String, Number],
        default: '',
      },
      height: {
        type: [String, Number],
        default: '',
      },
      alt: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        loaded: false,
        loading: false,
      };
    },
    computed: {
      mutableSrc() {
        return (this.loaded || this.loading || this.active)
          ? this.src
          : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
      },
    },
    watch: {
      active() {
        this.$nextTick(() => {
          this.load();
        });
      },
    },
    mounted() {
      this.load();
    },
    methods: {
      load() {
        if (!this.active || this.loaded || this.loading) return;
        this.loading = true;

        if (this.$refs.img) {
          this.$refs.img.onload = () => {
            this.loading = false;
            this.loaded = true;
          };
        }
      },
    },
  };
</script>

<template>
  <div
    class="carousel-lazy-image"
    :class="{ '_loading': loading, '_loaded': loaded }"
  >
    <img
      ref="img"
      :src="mutableSrc"
      :width="width"
      :height="height"
      :alt="alt"
      :class="imageClass"
    >
  </div>
</template>

<style lang="scss" type="text/scss" scoped>
  .carousel-lazy-image {
    &._loading::after {
      content: "";
      display: block;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -32px;
      margin-left: -32px;
      width: 64px;
      height: 64px;
      border-radius: 100%;
      border: 8px solid;
      border-top-color: $color-brand;
      border-right-color: $color-brand;
      border-left-color: $color-sub;
      border-bottom-color: $color-sub;
      transform: translateZ(0);
      animation: load8 1.1s infinite linear;
    }

    @keyframes load8 {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
</style>
